import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  Validators,
  FormGroup,
  ValidatorFn,
  AbstractControl,
  FormControl,
} from "@angular/forms";
import { CommonService } from "../common.service";
import { Router } from "@angular/router";
import { TokenLogService } from "../_services/tokenLogService";
import { XrmEntry } from "../_models/xrmEntry";
import { ClientSignUpCompany } from "../_models/clientSignUpCompany";
import { Contact } from "../_models/contact";
import { LogEntry } from "../_models/logEntry";
@Component({
  selector: "app-registration1",
  templateUrl: "./registration1.component.html",
  styleUrls: ["./registration1.component.css"],
})
export class Registration1Component implements OnInit {
  public secondRegistrationForm: FormGroup;
  public matching_passwords_group: FormGroup;
  public error: string;
  public authorizationPercentageError: any;
  public noOfUnitsError: any;
  public portalPasswordError: any;
  public portalConfirmPasswordError: any;
  public duplicateRefNoError: any = "";
  public clientRefResponse: any;
  public getFirstRegistrationFormVal: any;
  public getRegistrationFormVal: any;
  public apiResponseError: any;
  public apiResponseErrorMsg: any;
  public noOfPropertiesError: any;

  constructor(
    private _FB: FormBuilder,
    public authService: CommonService,
    private router: Router,
    private readonly tokenLogService: TokenLogService
  ) {
    this.secondRegistrationForm = this._FB.group({
      noOfUnits: [
        "",
        Validators.compose([
          Validators.pattern("^[0-9]*$"),
          Validators.required,
        ]),
      ],
      noOfProperties: [
        "",
        Validators.compose([
          Validators.pattern("^[0-9]*$"),
          Validators.required,
        ]),
      ],
      authorizationPercentage: [
        "Best: 50% (50% discount)",
        Validators.compose([Validators.required]),
      ],
      portalPassword: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(6),
          Validators.pattern(
            "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*]).{6,}$"
          ),
        ]),
      ],
      portalConfirmPassword: [
        "",
        Validators.compose([
          Validators.required,
          this.equalTo("portalPassword"),
        ]),
      ],
    });
  }

  get authorizationPercentage() {
    return this.secondRegistrationForm.get("authorizationPercentage");
  }
  get portalPassword() {
    return this.secondRegistrationForm.get("portalPassword");
  }
  get portalConfirmPassword() {
    return this.secondRegistrationForm.get("portalConfirmPassword");
  }

  ngOnInit() {
    const sessionStart = localStorage.getItem("sessionStart");
    if (sessionStart) {
      const savedDate = Date.parse(sessionStart);
      let diffInMs = Math.abs(Date.now() - savedDate);
      setTimeout(() => {
        const companyName = localStorage.getItem("companyName");
        const contactName = localStorage.getItem("contactName");
        const email = localStorage.getItem("email");
        const phone = localStorage.getItem("phone");
        const logEntry: LogEntry = {
          pageNumber: 3,
          companyName: companyName,
          vendorClientUniqueId: localStorage.getItem("vendorClientUniqueId"),
          message:
            "Session time out - redirected to timeout page after 60 minutes",
          exception: null,
          clientId: "",
          clientSecret: "",
          email: email,
          phone: phone,
          contactName: contactName,
          sessionId: localStorage.getItem("sessionId"),
          password: null,
          companyLegalName: null,
          numberOfProperties: 0,
          numberOfUnits: 0,
          street1: null,
          city: null,
          state: null,
          zipCode: null,
          country: null,
          settlementAuth: null,
          clientVendorId: 1,
        };
        this.tokenLogService
          .logEntry(logEntry)
          .toPromise()
          .then(
            () => {
              console.log("Token entry set correctly");
            },
            (error) => {
              console.log(
                "An error has occurred while creating log entry: ",
                error
              );
            }
          );
        this.router.navigateByUrl("timeout");
      }, 60 * 60 * 1000 - diffInMs);
    }
    this.getFirstRegistrationFormVal = JSON.parse(
      localStorage.getItem("firstRegistrationDetails")
    );
    // logging third page
    let companyName = localStorage.getItem("companyName");
    const clientId = localStorage.getItem("clientId");
    const clientSecret = localStorage.getItem("clientSecret");
    const email = localStorage.getItem("email");
    const phone = localStorage.getItem("phone");
    const contactName = localStorage.getItem("contactName");
    const logEntry: LogEntry = {
      pageNumber: 3,
      companyName: companyName,
      vendorClientUniqueId: localStorage.getItem("vendorClientUniqueId"),
      message: "Second registration page reached",
      exception: null,
      clientId: clientId,
      clientSecret: clientSecret,
      email: email,
      phone: phone,
      contactName: contactName,
      sessionId: localStorage.getItem("sessionId"),
      password: null,
      companyLegalName:
        this.getFirstRegistrationFormVal.firstRegistrationFormData.LegalName,
      numberOfProperties: 0,
      numberOfUnits: 0,
      street1:
        this.getFirstRegistrationFormVal.firstRegistrationFormData.Street1,
      city: this.getFirstRegistrationFormVal.firstRegistrationFormData.City,
      state: this.getFirstRegistrationFormVal.firstRegistrationFormData.State,
      zipCode:
        this.getFirstRegistrationFormVal.firstRegistrationFormData.ZipCode,
      country:
        this.getFirstRegistrationFormVal.firstRegistrationFormData.Country,
      settlementAuth: null,
      clientVendorId: 1,
    };
    this.tokenLogService
      .logEntry(logEntry)
      .toPromise()
      .then(
        () => {
          console.log("Token entry set correctly");
        },
        (error) => {
          console.log(
            "An error has occurred while creating log entry: ",
            error
          );
        }
      );
    this.getRegistrationFormVal = JSON.parse(
      localStorage.getItem("firstRegistrationDetails")
    );
    if (
      this.getRegistrationFormVal &&
      this.getRegistrationFormVal.companyDetailsObj
    ) {
      this.secondRegistrationForm.controls["noOfUnits"].setValue(
        this.getRegistrationFormVal.companyDetailsObj.NumberOfUnits
      );
      this.secondRegistrationForm.controls["noOfProperties"].setValue(
        this.getRegistrationFormVal.companyDetailsObj.NumberOfProperties
      );
      this.secondRegistrationForm.controls["authorizationPercentage"].setValue(
        this.getRegistrationFormVal.companyDetailsObj.SettlementAuth
      );
      this.secondRegistrationForm.controls["portalPassword"].setValue(
        this.getRegistrationFormVal.anotherDetailsObj.Password
      );
      this.secondRegistrationForm.controls["portalConfirmPassword"].setValue(
        this.getRegistrationFormVal.anotherDetailsObj.Password
      );
    }
  }

  equalTo(field_name): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      let input = control.value;

      if (input != "") {
        let isValid = control.root.value[field_name] == input;

        if (!isValid) return { equalTo: { isValid } };
        else return null;
      }
    };
  }

  clickFinalRegistration() {
    if (
      this.secondRegistrationForm.controls.noOfProperties.hasError("pattern")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.noOfPropertiesError = "Please enter a numeric value.";
    } else if (
      this.secondRegistrationForm.controls.noOfProperties.hasError("required")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.noOfPropertiesError = "Number of properties are required.";
    } else if (
      this.secondRegistrationForm.controls.noOfUnits.hasError("pattern")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.noOfUnitsError = "Please enter a numeric value.";
    } else if (
      this.secondRegistrationForm.controls.noOfUnits.hasError("required")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.noOfUnitsError = "Number of units are required.";
    } else if (
      this.secondRegistrationForm.controls.authorizationPercentage.hasError(
        "required"
      )
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.authorizationPercentageError =
        "Select any authorization percentage.";
    } else if (
      this.secondRegistrationForm.controls.portalPassword.hasError("required")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.portalPasswordError = "Client center password is required.";
    } else if (
      this.secondRegistrationForm.controls.portalPassword.hasError("minLength")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.portalPasswordError =
        "Client center Password must be at least 6 characters long.";
    } else if (
      this.secondRegistrationForm.controls.portalPassword.hasError("pattern")
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.portalPasswordError =
        "Your password must contain at least one uppercase, one lowercase, and one number and one special character.";
    } else if (
      this.secondRegistrationForm.controls.portalConfirmPassword.hasError(
        "required"
      )
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.portalConfirmPasswordError = "Confirm Password is required.";
    } else if (
      this.secondRegistrationForm.controls.portalConfirmPassword.hasError(
        "equalTo"
      )
    ) {
      const firstElementWithError = document.querySelector(".ng-invalid");
      firstElementWithError.scrollIntoView({ behavior: "smooth" });
      this.portalConfirmPasswordError = "Password did not match.";
    } else {
      let registrationFormData1;
      let registrationFormData;
      let companyDetailsObj = {};
      let physicalDetailsObj = {};
      let PhysicalAddress = {};
      let CheckAddress = {};
      let anotherDetailsObj = {};

      companyDetailsObj["Name"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"]["Name"];
      companyDetailsObj["LegalName"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "LegalName"
        ];
      companyDetailsObj["NumberOfUnits"] =
        this.secondRegistrationForm.controls["noOfUnits"].value;
      companyDetailsObj["NumberOfProperties"] =
        this.secondRegistrationForm.controls["noOfProperties"].value;
      companyDetailsObj["SettlementAuth"] =
        this.secondRegistrationForm.controls["authorizationPercentage"].value;
      companyDetailsObj["Id"] = "00000000-0000-0000-0000-000000000000";

      PhysicalAddress["Street1"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "Street1"
        ];
      PhysicalAddress["City"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"]["City"];
      PhysicalAddress["State"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"]["State"];
      PhysicalAddress["Country"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "Country"
        ];
      PhysicalAddress["ZipCode"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "ZipCode"
        ];
      companyDetailsObj["PhysicalAddress"] = PhysicalAddress;

      CheckAddress["Street1"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "checkAddressStreet1"
        ];
      CheckAddress["City"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "checkAddressCity"
        ];
      CheckAddress["State"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "checkAddressState"
        ];
      CheckAddress["Country"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "checkAddressCountryName"
        ];
      CheckAddress["ZipCode"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "checkAddressZipCode"
        ];
      companyDetailsObj["CheckAddress"] = CheckAddress;

      physicalDetailsObj["FirstName"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "FirstName"
        ];
      physicalDetailsObj["LastName"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "LastName"
        ];
      physicalDetailsObj["CellPhone"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "CellPhone"
        ];
      physicalDetailsObj["WorkPhone"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"][
          "WorkPhone"
        ];
      physicalDetailsObj["Email"] =
        this.getFirstRegistrationFormVal["firstRegistrationFormData"]["Email"];
      physicalDetailsObj["Id"] = "00000000-0000-0000-0000-000000000000";

      anotherDetailsObj["Password"] =
        this.secondRegistrationForm.controls["portalPassword"].value;
      registrationFormData = {
        companyDetailsObj,
        physicalDetailsObj,
        anotherDetailsObj,
      };
      registrationFormData1 = { registrationFormData };

      localStorage.setItem(
        "clientCenterNumber",
        companyDetailsObj["IntegrationIdentifier"]
      );
      localStorage.setItem("setContractPage", "1");
      localStorage.setItem(
        "registrationDetails",
        JSON.stringify(registrationFormData1)
      );

      // creating contact
      const contact: Contact = {
        jobTitle: "",
        firstName: registrationFormData.physicalDetailsObj.FirstName,
        lastName: registrationFormData.physicalDetailsObj.LastName,
        email: registrationFormData.physicalDetailsObj.Email,
        cellPhone: registrationFormData.physicalDetailsObj.CellPhone,
        workPhone: registrationFormData.physicalDetailsObj.WorkPhone,
        fax: "",
        homePhone: "",
      };
      localStorage.setItem("contact", JSON.stringify(contact));

      const clientId = localStorage.getItem("clientId");
      const clientSecret = localStorage.getItem("clientSecret");
      const token = localStorage.getItem("token");
      let sameAddress = false;
      if (
        companyDetailsObj["PhysicalAddress"].Street1 ==
          companyDetailsObj["CheckAddress"].Street1 &&
        companyDetailsObj["PhysicalAddress"].City ==
          companyDetailsObj["CheckAddress"].City &&
        companyDetailsObj["PhysicalAddress"].State ==
          companyDetailsObj["CheckAddress"].State &&
        companyDetailsObj["PhysicalAddress"].ZipCode ==
          companyDetailsObj["CheckAddress"].ZipCode &&
        companyDetailsObj["PhysicalAddress"].Country ==
          companyDetailsObj["CheckAddress"].Country
      ) {
        sameAddress = true;
      }
      // creating clientSignUp object
      const clientSignUpCompany: ClientSignUpCompany = {
        cPPassword: registrationFormData.anotherDetailsObj.Password,
        clientNumber: null,
        clientID: clientId,
        clientSecret: clientSecret,
        vendorClientUniqueId: localStorage.getItem("vendorClientUniqueId"),
        companyLegalName: registrationFormData.companyDetailsObj.LegalName,
        companyName: registrationFormData.companyDetailsObj.Name,
        contactFirstName: registrationFormData.physicalDetailsObj.FirstName,
        contactLastName: registrationFormData.physicalDetailsObj.LastName,
        contactCell: registrationFormData.physicalDetailsObj.CellPhone,
        contactEmail: registrationFormData.physicalDetailsObj.Email,
        contactPhone: registrationFormData.physicalDetailsObj.WorkPhone,
        numberOfProperties: companyDetailsObj["NumberOfProperties"],
        numberOfUnits: companyDetailsObj["NumberOfUnits"],
        physicalAddress: {
          street1: companyDetailsObj["PhysicalAddress"].Street1,
          street2: "",
          city: companyDetailsObj["PhysicalAddress"].City,
          state: companyDetailsObj["PhysicalAddress"].State,
          zipCode: companyDetailsObj["PhysicalAddress"].ZipCode,
          country: companyDetailsObj["PhysicalAddress"].Country,
        },
        checkAddressSameAsPhysical: sameAddress,
        settlementAuth: this.authorizationPercentage.value,
        sessionId: localStorage.getItem("sessionId"),
      };

      // creating XRM object
      const xrmEntry: XrmEntry = {
        name: registrationFormData.companyDetailsObj.Name,
        legalName: registrationFormData.companyDetailsObj.LegalName,
        settlementAuth: registrationFormData.companyDetailsObj.SettlementAuth,
        minLegalBalancePerClaim: 100,
        numberOfUnits: companyDetailsObj["NumberOfUnits"],
        numberOfProperties: companyDetailsObj["NumberOfProperties"],
        primaryContact: "00000000-0000-0000-0000-000000000000",
        statementAttentionContact: "00000000-0000-0000-0000-000000000000",
        acknowledgementContact: "00000000-0000-0000-0000-000000000000",
        documentRequestsContact: "00000000-0000-0000-0000-000000000000",
        informationRequestsContact: "00000000-0000-0000-0000-000000000000",
        paymentNotificationContact: "00000000-0000-0000-0000-000000000000",
        debtorFileChangeContact: "00000000-0000-0000-0000-000000000000",
        legalRequestsContact: "00000000-0000-0000-0000-000000000000",
        closureNotificationContact: "00000000-0000-0000-0000-000000000000",
        importID: "",
        statementAddress: {
          street1: companyDetailsObj["PhysicalAddress"].Street1,
          street2: "",
          city: companyDetailsObj["PhysicalAddress"].City,
          state: companyDetailsObj["PhysicalAddress"].State,
          zipCode: companyDetailsObj["PhysicalAddress"].ZipCode,
          country: companyDetailsObj["PhysicalAddress"].Country,
        },
        checkAddress: {
          street1: companyDetailsObj["CheckAddress"].Street1,
          street2: "",
          city: companyDetailsObj["CheckAddress"].City,
          state: companyDetailsObj["CheckAddress"].State,
          zipCode: companyDetailsObj["CheckAddress"].ZipCode,
          country: companyDetailsObj["CheckAddress"].Country,
        },
        invoiceAddress: {
          street1: companyDetailsObj["PhysicalAddress"].Street1,
          street2: "",
          city: companyDetailsObj["PhysicalAddress"].City,
          state: companyDetailsObj["PhysicalAddress"].State,
          zipCode: companyDetailsObj["PhysicalAddress"].ZipCode,
          country: companyDetailsObj["PhysicalAddress"].Country,
        },
        physicalAddress: {
          street1: companyDetailsObj["PhysicalAddress"].Street1,
          street2: "",
          city: companyDetailsObj["PhysicalAddress"].City,
          state: companyDetailsObj["PhysicalAddress"].State,
          zipCode: companyDetailsObj["PhysicalAddress"].ZipCode,
          country: companyDetailsObj["PhysicalAddress"].Country,
        },
        importantCaseNotes: "",
        importantDataEntryNotes: "",
        country: {},
      };
      localStorage.setItem(
        "password",
        registrationFormData.anotherDetailsObj.Password
      );
      localStorage.setItem(
        "clientSignUpCompany",
        JSON.stringify(clientSignUpCompany)
      );
      localStorage.setItem("xrmEntry", JSON.stringify(xrmEntry));
      this.router.navigate(["/contract"]);
    }
  }

  onOptionsSelected(event) {
    if (event == 100) {
      alert(
        "Are you sure? Not enabling a settlement offer can have a dramatic impact on our ability to collect on your accounts."
      );
    }
  }
}
